import { TlsVersion } from '../../../common/handshakes/enums/TlsVersion';

export class Ciphersuite {
  constructor(
    private readonly id: number,
    private readonly name: string | null,
    private readonly recommended: boolean,
    private readonly reference: string[],
    private readonly version: TlsVersion,
    private readonly modeOfOperation: string | null,
    private readonly keyExchangeAlgorithm: string | null,
    private readonly hashAlgorithm: string | null,
    private readonly authenticationAlgorithm: string | null,
    private readonly symmetricAlgorithm: string | null,
    private readonly macAlgorithm: string | null
  ) {}

  getId() {
    return this.id;
  }

  getKeyExchangeAlgorithm() {
    return this.keyExchangeAlgorithm;
  }

  getName() {
    return this.name;
  }

  getProtocolName() {
    if (this.name === null) {
      return null;
    }

    return this.name.split('_')[0] ?? null;
  }

  getRecommended() {
    return this.recommended;
  }

  getReference() {
    return this.reference;
  }

  getVersion() {
    return this.version;
  }

  getModeOfOperation() {
    return this.modeOfOperation;
  }

  getHashAlgorithm() {
    return this.hashAlgorithm;
  }

  getAuthenticationAlgorithm() {
    return this.authenticationAlgorithm;
  }

  getSymmetricAlgorithm() {
    return this.symmetricAlgorithm;
  }

  getMacAlgorithm() {
    return this.macAlgorithm;
  }
}
